/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import * as _ from 'lodash'
import { List, Checkbox, Badge, message } from 'antd'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
// css
import { Point, TxtLimit, ModalBg, BadgeStyle } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { SportsIco } from '@styles/match.style'
import LeagueEmblemImg from '@assets/images/icon/emblem_icon/league.png'
import { Schema$MatchupFilter } from '@v2/interface/matchup'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import { Schema$MajorTournamentFilter } from '@protocol/game'
import useRootStore from '@store/useRootStore'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { isLsportsEnv } from '@utils/utils'
import { ResetIco } from '@shared/Icon/EtcIcon'
import {
  FilterHeader,
  FilterList,
  FilterWrapStyle,
  ListBtnStyle,
  PointStyle,
} from './index.style'
import { PAGE_TYPE, SPORTS_TYPE } from '@interface/common'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'

export function getLogoShieldIco(e) {
  e.target.src = LeagueEmblemImg
}

interface RenderTrack {
  track: Schema$MatchupFilter
  matchCount: number
}

const MatchupFilterPopup: React.FC = () => {
  const { matchupStore, globalStore, userPickStore, logStore } = useRootStore()
  const {
    majorTournamentFilters,
    currentSportsKey,
    matchupFilterList = [] as Schema$MatchupFilter[],
    pageType,
    currentSportId,
  } = matchupStore
  const { filteredTargetSportId } = userPickStore
  const [selectedLeagues, setSelectedLeagues] = useState([])
  const { visibleMatchupFilterSelectPopup } = globalStore

  if (!visibleMatchupFilterSelectPopup) {
    return null
  }

  const onClickItem = (uniqueId: number, name: string, subName?: string, emblemTour?: string, sportId?: number) => {
    if (pageType === PAGE_TYPE.USER_PICK) {
      if (sportId === -2) {
        userPickStore.setFilteredTargetSportId(undefined)
      } else {
        userPickStore.setFilteredTargetSportId(sportId)
      }
      userPickStore.fetchUserPickMatchesPackage().catch(console.error)
      globalStore.setVisibleMatchupFilterSelectPopup(false)
    } else {
      if (!_.isNil(sportId)) {
        matchupStore.setSportId(sportId)
      }
      globalStore.setVisibleMatchupFilterSelectPopup(false)
      matchupStore.onClickMatchupPopupFilter(uniqueId)
    }
  }

  function renderRowTournament(
    majorTournamentFilters: Schema$MajorTournamentFilter[],
    el: Schema$MatchupFilter,
    onClickItem: (
      uniqueId: number, name: string, subName?: string, emblemTournament?: string, sportId?: number
    ) => void,
  ) {
    const { UniqueID, CategoryName, TournamentName, matchCount, emblemTournament, SportID } = el
    // const onClickTournamentItemButton = () => onClickItem(UniqueID, CategoryName, TournamentName, emblemTournament, Number(SportID))
    const isTopLeague = _.find(majorTournamentFilters, { SportID, UniqueID })

    const sportIcoImg = isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SportID] : SPORT_ID_ICON_MAP[SportID]
    return (
      <List.Item>
        <Checkbox value={UniqueID}>
          <span css={TxtLimit} className="category-name">
            <SportsIco css={{ marginRight: 4}}>{sportIcoImg}</SportsIco>
            {CategoryName}
            </span>
          <span className="league-wrap">
            <img src={emblemTournament} alt="cate" onError={getLogoShieldIco} className="emblem"/>
            <span className="league-name" css={TxtLimit}>
              {TournamentName}
            </span>
            {isTopLeague && <span className="top">
              <span className="top--txt">주요</span>
            </span>}
          </span>

          <Point css={PointStyle}>{matchCount}</Point>
        </Checkbox>
      </List.Item>
    )
  }

  function renderRowSport(
    majorTournamentFilters: Schema$MajorTournamentFilter[],
    el: RenderTrack,
    onClickItem: (
      uniqueId: number, name: string, subName?: string, emblemTournament?: string, sportId?: number,
    ) => void,
  ) {
    const { track, matchCount } = el
    const { SportName, SportID } = track

    let style = {}
    if (SportID === currentSportId
      || SportID === filteredTargetSportId
      || (!filteredTargetSportId && SportID === -2)
    ) {
      style = {
        background: 'rgba(37,114,118,.15)',
        border: '1px solid rgba(37,114,118,.5)'
      }
    }
    const onClickSportItemButton = () => onClickItem(SportID, SportName, null, null, SportID)
    return (
      <Button css={ListBtnStyle} onClick={onClickSportItemButton} style={style}>
        <List.Item>
        <span className="league-wrap sport">
          <SportsIco
            className="etc-sports-ico">{isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SportID] : SPORT_ID_ICON_MAP[SportID] || SPORT_ID_ICON_MAP['178']}
          </SportsIco>
          <span className="league-name" css={TxtLimit}>
            {SportName}
          </span>
        </span>
          <Point css={PointStyle}>{matchCount}</Point>
        </List.Item>
      </Button>
    )
  }

  const LEAGUE_SELECTION_LIMIT_COUNT = 10

  function onChange(checkedValues: Array<CheckboxValueType>): void {
    let leagues = checkedValues

    if (checkedValues.length > LEAGUE_SELECTION_LIMIT_COUNT) {
      leagues = _.slice(checkedValues, 0, checkedValues.length - 1)
      message.info('최대 개수를 초과하였습니다.')
    }

    setSelectedLeagues(leagues)
  }

  const onClickResetFilter = () => {
    setSelectedLeagues([])
  }

  let header: React.ReactElement
  const filterListClone = toJS(matchupFilterList)
  const filtered = _.filter(filterListClone, o => {
    if (Number(currentSportsKey) > 0) {
      return o.matchCount > 0 && o.SportID === Number(currentSportsKey)
    }
    return o.matchCount > 0
  })
  let tracks = []
  let renderRow: (
    majorTournamentFilters: Schema$MajorTournamentFilter[],
    el: RenderTrack | Schema$MatchupFilter,
    onClickItem: (
      uniqueId: number, name: string, subName?: string, emblemTournament?: string, sportId?: number,
    ) => void,
  ) => React.ReactElement
  if (currentSportsKey === SPORTS_TYPE.ETC) { // 기타종목
    // TODO
    header = <div>종목 선택</div>
    renderRow = renderRowSport
    const sportGroup = _.groupBy(filtered, o => {
      return o.SportID
    })
    let totalMatch = 0
    for (const el in sportGroup) {
      const obj = sportGroup[el][0]
      const matchSum = _.sumBy(sportGroup[el], 'matchCount')
      totalMatch += matchSum
      tracks.push({
        track: obj,
        matchCount: matchSum,
      })
    }
    if (pageType === PAGE_TYPE.USER_PICK) {
      tracks.unshift({
        track: { SportName: '전체', SportID: -2 },
        matchCount: totalMatch
      })
    }
  } else {
    header = (
      <FilterHeader>
        <Button TP className={_.size(selectedLeagues) === 0 ? 'reset-btn' : 'reset-btn active'}
                onClick={onClickResetFilter}>
          <ResetIco/>
        </Button>
        리그필터
        {/* 0일때도 보여야하기 떄문에 antd의 Badge 사용*/}
        <Badge count={_.size(selectedLeagues)} showZero css={BadgeStyle}
               className={_.size(selectedLeagues) === 0 ? 'filter-badge zero' : 'filter-badge'}/>
      </FilterHeader>
    )
    renderRow = renderRowTournament
    const topTrack = []
    const etcTrack = []
    let sportIds = []
    const orderMajorTournamentFilters = _.orderBy(majorTournamentFilters, ['SportID', 'OrderInSport'], ['asc', 'asc'])
    for (const el of orderMajorTournamentFilters) {
      const filteredItem = _.find(filtered, { SportID: el.SportID, UniqueID: el.UniqueID })
      if (filteredItem) {
        filteredItem.OrderInSport = el.OrderInSport
      }
    }
    const orderFiltered = _.orderBy(filtered, ['SportID', 'OrderInSport', 'CategoryName', 'TournamentName'], ['asc', 'asc', 'asc', 'asc'])
    for (const el of orderFiltered) {
      const top = _.find(majorTournamentFilters, { SportID: el.SportID, UniqueID: el.UniqueID })
      sportIds.push(el.SportID)
      if (top) {
        topTrack.push(el)
      } else {
        etcTrack.push(el)
      }
    }
    sportIds = _.uniq(sportIds)
    const topGroup = _.groupBy(topTrack, 'SportID')
    const etcGroup = _.groupBy(etcTrack, 'SportID')
    for (const el of sportIds) {
      if (topGroup[el]) {
        tracks = tracks.concat(topGroup[el])
      }
    }
    for (const el of sportIds) {
      if (etcGroup[el]) {
        tracks = tracks.concat(etcGroup[el])
      }
    }
  }

  const renderFilterListItem = (item: Schema$MatchupFilter) => {
    return renderRow(majorTournamentFilters, item, onClickItem)
  }

  const localeAdvEmpty = { emptyText: <AdvEmpty ico={EMPTY_ICON.MATCH_FILTER}/> }

  const onClose = () => {
    globalStore.setVisibleMatchupFilterSelectPopup(false)
  }

  const showFilterPopup = () => {
    if (currentSportsKey !== SPORTS_TYPE.ETC && _.size(selectedLeagues) > 0) {
      const leagueIds = selectedLeagues.sort((a, b) => {
        const aIndex = _.findIndex(tracks, track => _.isEqual(track.TournamentID, a))
        const bIndex = _.findIndex(tracks, track => _.isEqual(track.TournamentID, b))

        return aIndex - bIndex
      })
      if (pageType !== PAGE_TYPE.USER_PICK) {
        matchupStore.setMatchupListState()
      }

      matchupStore.setTournamentFilterList(leagueIds)
      globalStore.setVisibleMatchFilterPopup(true)
    }
  }

  const onClickFilter = () => {
    if (currentSportsKey !== SPORTS_TYPE.ETC && _.size(selectedLeagues) > 0) {
      const leagueNames: string[] = []
      _.forEach(selectedLeagues, (leagueId) => {
        const league = _.find(tracks, { UniqueID: leagueId })
        if (league) {
          leagueNames.push(league.TournamentName)
        }
      })
      if (!_.isEmpty(leagueNames)) {
        logStore.writeButtonLog({ pageId: 'b040', buttonId: '001', buttonDetails: leagueNames.join(',') }).catch(console.error)
      }
    }
    onClose()
    showFilterPopup()
    onClickResetFilter()
  }

  const onClickClose = () => {
    onClose()
    onClickResetFilter()
  }

  return (
    <Fragment>
      {/* filter-popup custom-dialog */}
      <Modal
        transparent
        maskClosable={false}
        css={AdvDialogStyle}
        className="adv-new-dialog box-type big-size league-filter"
        visible={visibleMatchupFilterSelectPopup}
        onClose={onClose}
      >
        <div css={FilterWrapStyle}>
          {currentSportsKey === SPORTS_TYPE.ETC ?
            <List
              className="filter-list"
              css={FilterList}
              header={header}
              bordered
              dataSource={tracks}
              renderItem={renderFilterListItem}
              locale={localeAdvEmpty}
            />
            :
            <Checkbox.Group
              value={selectedLeagues}
              onChange={onChange}
            >
              <List
                className="filter-list"
                css={FilterList}
                header={header}
                bordered
                dataSource={tracks}
                renderItem={renderFilterListItem}
                locale={localeAdvEmpty}
              />
            </Checkbox.Group>
          }
          {/*<ButtonWrap className="custom-dialog-btn-wrap">*/}
          {/*  <Button primary onClick={onClose} css={PopupBtnStyle} className="one-button">*/}
          {/*    확인*/}
          {/*  </Button>*/}
          {/*</ButtonWrap>*/}
        </div>

        <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
          <Button secondary className="single-btn" onClick={onClickFilter}>
            확인
          </Button>
        </AdvDialogBtnWrap>
        <ModalBg onClick={onClickClose}/>
      </Modal>
    </Fragment>
  )
}

export default observer(MatchupFilterPopup)
